import { FC } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { useRouteParams } from "app/route/route";
import { reportVersionVulnerabilityRoute, acceptRiskReportVersionVulnerabilityRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { ReportVulnerabilityStatus, useReportVulnerabilityQuery } from "app/api/graph/types";
import { reportVulnerabilityGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { AcceptRiskReportVulnerabilityForm } from "app/component/report-vulnerability/AcceptRiskReportVulnerabilityForm";

export const AcceptRiskReportVersionVulnerabilityScreen: FC = () => {
    const { reportId, versionId, vulnerabilityId } = useRouteParams(acceptRiskReportVersionVulnerabilityRoute);
    const { data, loading, error } = useReportVulnerabilityQuery({
        variables: { vulnerabilityId: reportVulnerabilityGraphId(vulnerabilityId) },
    });
    const vulnerability = data?.reportVulnerability;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!vulnerability) {
        return <ErrorScreen title="Error" message="Not found" />;
    }
    if (vulnerability.status !== ReportVulnerabilityStatus.Open) {
        return <Navigate to={reportVersionVulnerabilityRoute.build({ reportId, versionId, vulnerabilityId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={acceptRiskReportVersionVulnerabilityRoute} />
                <h1>
                    <strong>{vulnerability.issueNumber}</strong> {vulnerability.title}
                </h1>
                <AcceptRiskReportVulnerabilityForm vulnerabilityId={vulnerabilityId} />
            </Container>
        </NavigationScreen>
    );
};
